import { useEffect } from 'react'
import { setLoginCookie } from '../../_lib/loginCookie'
import { LOGIN_PATH } from '../../_lib/festival'
import { cacheDatabaseName } from '../../_lib/graphql/exchanges/cacheExchange'
import { FestivalLoading } from '../FestivalContext/FestivalLoading'

// Räumt Sitzung und gecachten Benutzer auf, damit /login nicht sofort wieder ins Portal weiterleitet
export const LogoutRedirect = () => {
  useEffect(() => {
    indexedDB.deleteDatabase(cacheDatabaseName)
    localStorage.removeItem('token')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('expiredTimestamp')
    setLoginCookie(false)
    window.location.replace(LOGIN_PATH)
  }, [])

  return (
    <FestivalLoading />
  )
}
